import React from 'react';
import { HTTP_STATUS_FOUND } from 'cityads-v3/utils/apiUtils';
import RedirectWithCode from './RedirectWithCode';

export default function TemporaryRedirect(props) {
  return (
    <RedirectWithCode {...props} code={HTTP_STATUS_FOUND} />
  );
}
